import { create } from 'zustand';
import createReplaceCardSlice from './replaceCardSlice';
export const useStore = create((set, get) => (Object.assign({}, createReplaceCardSlice(set, get))));
//# sourceMappingURL=store.js.map